// KindergartenDetails.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';

import { Container, Row, Col } from 'react-bootstrap';

import KindergartenInfo from './generalinfo';
import KindergartenMainInfo from './maininfo';
import KindergartenBadge from './badge';
import KindergartenTitleBlock from './KindergartenTitleBlock';
import { getKindergartenInfo } from './actions';

import MapPlaceholder from '../../../components/MapPlaceholder/MapPlaceholder';

import './KindergartenDetails.css';

const KindergartenDetails = () => {

  const {id} = useParams();

  const [kindergartenData, setData] = useState(null);


  useEffect(()=>{
    async function getData() {
      setData(await getKindergartenInfo({id}));
    }

    getData();
  }, []);

  if(!kindergartenData) return null;

  return (
    <div className="kindergarten-details-container">
      {/* Map Section — без змін порівняно з оригіналом */}

      <MapPlaceholder kglist={[kindergartenData]}/>

      {/* Content Section */}
      <Container className="content-section">
        <Row>
          <Col lg={8}>
            {/* Заголовок + фото впритул зліва (варіант B) — якщо
                обкладинки немає, KindergartenTitleBlock сам рендерить
                звичайний h1+badges без картки */}
            <KindergartenTitleBlock kindergartenData={kindergartenData}>
              <KindergartenBadge kindergartenData={kindergartenData}/>
            </KindergartenTitleBlock>

            {/* Таби + контент — окремо від фото, щоб edge-to-edge фото
                не тягнулось на всю висоту довгого контенту вкладки */}
            <div className="kindergarten-header">
              <KindergartenMainInfo kindergartenData={kindergartenData}/>
            </div>
          </Col>

          <Col lg={4}>
            {/* Contact Info Card */}
            <KindergartenInfo kindergartenData={kindergartenData}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default KindergartenDetails;